export default __webpack_public_path__ + "static/media/Jenne Alderks.0b489b73.jpg";